export default __webpack_public_path__ + "static/media/onlineOrder.b16aa652.png";